import Head from "next/head";
import React from "react";
import fs from "fs";
import path from "path";
import { GetStaticProps } from "next";

interface TutorPageProps {
  htmlContent: string;
}

const TutorPage: React.FC<TutorPageProps> = ({ htmlContent }) => {
  return (
    <>
      <Head>
        <title>
          CoLearn Tutor | Bebaskan anak Anda dari jawaban instan AI.
        </title>
        <link rel="preconnect" href="https://fonts.googleapis.com" />
        <link
          rel="preconnect"
          href="https://fonts.gstatic.com"
          crossOrigin=""
        />
        <link
          href="https://fonts.googleapis.com/css2?family=Poppins:wght@400;700&display=swap"
          rel="stylesheet"
        />
        <link
          href="https://fonts.googleapis.com/css?family=Overpass"
          rel="stylesheet"
        />
        <link rel="stylesheet" href="/assets/tutor/styles.css" />
      </Head>

      <main dangerouslySetInnerHTML={{ __html: htmlContent }} />
    </>
  );
};

export const getStaticProps: GetStaticProps<TutorPageProps> = async () => {
  const filePath = path.join(process.cwd(), "src/pages/tutor/content.html");
  const htmlContent = fs.readFileSync(filePath, "utf8");

  return {
    props: {
      htmlContent
    }
  };
};

export default TutorPage;
